
const employeesData = [
    {
        id: 1,
        firstName: "George",
        lastName: "Muller",
        email: "example@gmai.com",
        salary: "10000",
        date: "2021-01-09"
    },
    {
        id: 2,
        firstName: "Mary",
        lastName: "Whales",
        email: "example@gmai.com",
        salary: "87000",
        date: "2021-01-18"
    },
    {
        id: 3,
        firstName: "Ericka",
        lastName: "Morera",
        email: "example@gmai.com",
        salary: "95000",
        date: "2020-02-09"
    },
    {
        id: 4,
        firstName: "John",
        lastName: "Davis",
        email: "example@gmai.com",
        salary: "80000",
        date: "2021-05-05"
    },
    {
        id: 5,
        firstName: "Christian",
        lastName: "Jordan",
        email: "example@gmai.com",
        salary: "56000",
        date: "2022-01-04"
    },
    {
        id: 6,
        firstName: "Kelvin",
        lastName: "Cirus",
        email: "example@gmai.com",
        salary: "88000",
        date: "2022-01-09"
    },
    {
        id: 7,
        firstName: "Williams",
        lastName: "Kent",
        email: "example@gmai.com",
        salary: "75000",
        date: "2022-01-05"
    },
    {
        id: 8,
        firstName: "Doak",
        lastName: "Casper",
        email: "example@gmai.com",
        salary: "45000",
        date: "2021-04-10"
    },
    {
        id: 9,
        firstName: "James",
        lastName: "Bond",
        email: "example@gmai.com",
        salary: "80000",
        date: "2021-05-08"
    },
    {
        id: 10,
        firstName: "Clara",
        lastName: "Jones",
        email: "example@gmai.com",
        salary: "80000",
        date: "2020-05-05"
    }
];

export { employeesData };